var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../core/js/filters/nunjucks-config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});
dependencies["quickshop-actions/quickshop-owner-actions-outer.j2"] = require( "quickshop-actions/quickshop-owner-actions-outer.j2" );
dependencies["product-add-to-cart.j2"] = require( "product-add-to-cart.j2" );
dependencies["quickshop-actions/see-similar-items.j2"] = require( "quickshop-actions/see-similar-items.j2" );
dependencies["quickshop-actions/quickshop-remove-link-outer.j2"] = require( "quickshop-actions/quickshop-remove-link-outer.j2" );
dependencies["product-list-messages.j2"] = require( "product-list-messages.j2" );
dependencies["product-registry-add.j2"] = require( "product-registry-add.j2" );
dependencies["product-wishlist-add.j2"] = require( "product-wishlist-add.j2" );
dependencies["product-registry-list.j2"] = require( "product-registry-list.j2" );
dependencies["product-wishlist-list.j2"] = require( "product-wishlist-list.j2" );




var shim = require("/jh/workspace/MonoWeb-Build-Release/monoweb/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["product/templates/product-sku-actions-quickshop.j2"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
output += "\n\n<div class=\"c-quickshop__sku-container dom-quickshop-sku-actions\" data-qa-quickshop-sku-actions>\n\n    <div class=\"";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "quickshop")),"ownerView")) {
output += "o-row ";
;
}
output += "o-column o-extra-small--12 o-extra-large--10\">\n\n        ";
if(!runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "product")),"productUnavailable") && !runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "product")),"isSoldOut") && !(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "quickshop")),"shopperView") && runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "quickshop")),"product")),"selectedSku")),"availabilityInfo")),"isOutOfStock"))) {
output += "\n\n            ";
var t_1;
t_1 = (runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "product")),"productRegistry") && runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "product")),"productRegistry")),"selectedItem") && runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "product")),"productRegistry")),"selectedItem")),"purchased_quantity") > 0?true:false);
frame.set("isPartiallyOrEntirelyFulfilled", t_1, true);
if(frame.topLevel) {
context.setVariable("isPartiallyOrEntirelyFulfilled", t_1);
}
if(frame.topLevel) {
context.addExport("isPartiallyOrEntirelyFulfilled", t_1);
}
output += "\n            ";
var t_2;
t_2 = (lineno = 10, colno = 47, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_get"), "_get", context, ["product.selectedSku.availabilityInfo.isOutOfStock",false]));
frame.set("selectedSkuIsOutOfStock", t_2, true);
if(frame.topLevel) {
context.setVariable("selectedSkuIsOutOfStock", t_2);
}
if(frame.topLevel) {
context.addExport("selectedSkuIsOutOfStock", t_2);
}
output += "\n            ";
var t_3;
t_3 = runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "quickshop")),"isOpen") && runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "quickshop")),"source") == "registry";
frame.set("registryIsOpen", t_3, true);
if(frame.topLevel) {
context.setVariable("registryIsOpen", t_3);
}
if(frame.topLevel) {
context.addExport("registryIsOpen", t_3);
}
output += "\n\n            ";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "quickshop")),"ownerView")) {
output += "\n\n                <div>\n\n                    ";
if(!(runtime.contextOrFrameLookup(context, frame, "isPartiallyOrEntirelyFulfilled") && runtime.contextOrFrameLookup(context, frame, "registryIsOpen")) || (runtime.contextOrFrameLookup(context, frame, "isPartiallyOrEntirelyFulfilled") && !runtime.contextOrFrameLookup(context, frame, "selectedSkuIsOutOfStock"))) {
output += "\n\n                        ";
env.getTemplate("quickshop-actions/quickshop-owner-actions-outer.j2", false, "product/templates/product-sku-actions-quickshop.j2", null, function(t_6,t_4) {
if(t_6) { cb(t_6); return; }
t_4.render(context.getVariables(), frame, function(t_7,t_5) {
if(t_7) { cb(t_7); return; }
output += t_5
output += "\n\n                    ";
})});
}
output += "\n\n                </div>\n\n            ";
;
}
else {
output += "\n\n                <div class=\"c-product-add-to-cart\">\n                    ";
output += "\n\n                    ";
env.getTemplate("product-add-to-cart.j2", false, "product/templates/product-sku-actions-quickshop.j2", null, function(t_10,t_8) {
if(t_10) { cb(t_10); return; }
t_8.render(context.getVariables(), frame, function(t_11,t_9) {
if(t_11) { cb(t_11); return; }
output += t_9
output += "\n                </div>\n\n            ";
})});
}
output += "\n\n        ";
;
}
output += "\n\n    </div>\n\n    <ul class=\"o-row c-product-add-links\">\n\n        ";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "product")),"productUnavailable") || runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "product")),"isSoldOut") || runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "product")),"selectedSku")),"availabilityInfo")),"isOutOfStock")) {
output += "\n\n            ";
env.getTemplate("quickshop-actions/see-similar-items.j2", false, "product/templates/product-sku-actions-quickshop.j2", null, function(t_14,t_12) {
if(t_14) { cb(t_14); return; }
t_12.render(context.getVariables(), frame, function(t_15,t_13) {
if(t_15) { cb(t_15); return; }
output += t_13
output += "\n\n            ";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "quickshop")),"showRemoveCartItem")) {
output += "\n                ";
output += "\n                ";
env.getTemplate("quickshop-actions/quickshop-remove-link-outer.j2", false, "product/templates/product-sku-actions-quickshop.j2", null, function(t_18,t_16) {
if(t_18) { cb(t_18); return; }
t_16.render(context.getVariables(), frame, function(t_19,t_17) {
if(t_19) { cb(t_19); return; }
output += t_17
output += "\n            ";
})});
}
output += "\n\n        ";
})});
}
else {
output += "\n\n            ";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "quickshop")),"ownerView") && runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "quickshop")),"showAddToCart")) {
output += "\n                ";
output += "\n                ";
env.getTemplate("product-add-to-cart.j2", false, "product/templates/product-sku-actions-quickshop.j2", null, function(t_22,t_20) {
if(t_22) { cb(t_22); return; }
t_20.render(context.getVariables(), frame, function(t_23,t_21) {
if(t_23) { cb(t_23); return; }
output += t_21
output += "\n            ";
})});
}
output += "\n\n            ";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "quickshop")),"showRemoveCartItem")) {
output += "\n                ";
output += "\n                ";
env.getTemplate("quickshop-actions/quickshop-remove-link-outer.j2", false, "product/templates/product-sku-actions-quickshop.j2", null, function(t_26,t_24) {
if(t_26) { cb(t_26); return; }
t_24.render(context.getVariables(), frame, function(t_27,t_25) {
if(t_27) { cb(t_27); return; }
output += t_25
output += "\n            ";
})});
}
output += "\n\n            ";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "quickshop")),"showAddToRegistry") || runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "quickshop")),"showAddToWishlist")) {
output += "\n                ";
output += "\n                ";
env.getTemplate("product-list-messages.j2", false, "product/templates/product-sku-actions-quickshop.j2", null, function(t_30,t_28) {
if(t_30) { cb(t_30); return; }
t_28.render(context.getVariables(), frame, function(t_31,t_29) {
if(t_31) { cb(t_31); return; }
output += t_29
output += "\n            ";
})});
}
output += "\n\n            ";
if(!runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "product")),"product")),"isGiftCard") && !runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "product")),"product")),"isEgiftCard")) {
output += "\n\n                ";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "quickshop")),"showAddToRegistry") && (runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"siteId") == "an-us" || runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"siteConfig")),"siteGroup") == "an-us")) {
output += "\n                    ";
env.getTemplate("product-registry-add.j2", false, "product/templates/product-sku-actions-quickshop.j2", null, function(t_34,t_32) {
if(t_34) { cb(t_34); return; }
t_32.render(context.getVariables(), frame, function(t_35,t_33) {
if(t_35) { cb(t_35); return; }
output += t_33
output += "\n                ";
})});
}
output += "\n\n                ";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "quickshop")),"showAddToWishlist")) {
output += "\n                    ";
output += "\n                    ";
env.getTemplate("product-wishlist-add.j2", false, "product/templates/product-sku-actions-quickshop.j2", null, function(t_38,t_36) {
if(t_38) { cb(t_38); return; }
t_36.render(context.getVariables(), frame, function(t_39,t_37) {
if(t_39) { cb(t_39); return; }
output += t_37
output += "\n                ";
})});
}
output += "\n\n                ";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "quickshop")),"showAddToRegistry")) {
output += "\n                    ";
output += "\n                    ";
env.getTemplate("product-registry-list.j2", false, "product/templates/product-sku-actions-quickshop.j2", null, function(t_42,t_40) {
if(t_42) { cb(t_42); return; }
t_40.render(context.getVariables(), frame, function(t_43,t_41) {
if(t_43) { cb(t_43); return; }
output += t_41
output += "\n                ";
})});
}
output += "\n\n                ";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "quickshop")),"showAddToWishlist")) {
output += "\n                    ";
output += "\n                    ";
env.getTemplate("product-wishlist-list.j2", false, "product/templates/product-sku-actions-quickshop.j2", null, function(t_46,t_44) {
if(t_46) { cb(t_46); return; }
t_44.render(context.getVariables(), frame, function(t_47,t_45) {
if(t_47) { cb(t_47); return; }
output += t_45
output += "\n                ";
})});
}
output += "\n\n            ";
;
}
output += "\n\n        ";
;
}
output += "\n\n    </ul>\n\n</div>\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["product/templates/product-sku-actions-quickshop.j2"] , dependencies)